// @flow
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from "@material-ui/core/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
    textarea: {
        minHeight: 57,
    }
});

type Props = $ReadOnly<{
    multiple?: boolean,

    onSubmit: (message) => void
}>;

function NewMessage({ multiple, onSubmit }: Props) {
    const classes = useStyles();
    const [message, setMessage] = useState('');

    const handleChange = (e) => setMessage(e.target.value);
    const handleSubmit = (e) => {
        e.preventDefault();

        if(message) {
            onSubmit(message);
            setMessage('');
        }
    };

    return (
        <Box pb={4}>
            <form noValidate onSubmit={handleSubmit}>
                <Box mb={2}>
                    <TextField
                        id="message"
                        label={multiple ? <FormattedMessage
                            id="newMessage.toaAllAehicles"
                            defaultMessage="Send message to all vehicles"
                        /> : <FormattedMessage
                            id="newMessage.toVehicle"
                            defaultMessage="Send message to vehicle"
                        />}
                        multiline={true}
                        margin="none"
                        variant="filled"
                        value={message}
                        fullWidth
                        onChange={handleChange}
                        InputProps={{
                            classes: {
                                input: classes.textarea
                            }
                        }}
                    />
                </Box>
                <Box display="flex" justifyContent="flex-end">
                    <Button size="large" type="submit" color="primary" variant="contained">
                        <FormattedMessage
                            id="newMessage.send"
                            defaultMessage="Send"
                        />
                    </Button>
                </Box>
            </form>
        </Box>
    );
}

export default NewMessage;